__turbopack_context__.v({
  "body": "learning-cycle-module__I5UXMG__body",
  "bullets": "learning-cycle-module__I5UXMG__bullets",
  "control": "learning-cycle-module__I5UXMG__control",
  "controlIcon": "learning-cycle-module__I5UXMG__controlIcon",
  "controlLabel": "learning-cycle-module__I5UXMG__controlLabel",
  "controller": "learning-cycle-module__I5UXMG__controller",
  "eyebrow": "learning-cycle-module__I5UXMG__eyebrow",
  "fadeIn": "learning-cycle-module__I5UXMG__fadeIn",
  "insetIn": "learning-cycle-module__I5UXMG__insetIn",
  "label": "learning-cycle-module__I5UXMG__label",
  "labelActive": "learning-cycle-module__I5UXMG__labelActive",
  "mute": "learning-cycle-module__I5UXMG__mute",
  "muteDisc": "learning-cycle-module__I5UXMG__muteDisc",
  "nodeRing": "learning-cycle-module__I5UXMG__nodeRing",
  "note": "learning-cycle-module__I5UXMG__note",
  "noteIcon": "learning-cycle-module__I5UXMG__noteIcon",
  "noteText": "learning-cycle-module__I5UXMG__noteText",
  "panel": "learning-cycle-module__I5UXMG__panel",
  "patch": "learning-cycle-module__I5UXMG__patch",
  "pulse": "learning-cycle-module__I5UXMG__pulse",
  "relight": "learning-cycle-module__I5UXMG__relight",
  "ring": "learning-cycle-module__I5UXMG__ring",
  "ringArc": "learning-cycle-module__I5UXMG__ringArc",
  "ringSvg": "learning-cycle-module__I5UXMG__ringSvg",
  "ringTrack": "learning-cycle-module__I5UXMG__ringTrack",
  "root": "learning-cycle-module__I5UXMG__root",
  "rule": "learning-cycle-module__I5UXMG__rule",
  "sonar": "learning-cycle-module__I5UXMG__sonar",
  "spark": "learning-cycle-module__I5UXMG__spark",
  "status": "learning-cycle-module__I5UXMG__status",
  "statusPaused": "learning-cycle-module__I5UXMG__statusPaused",
  "statusRing": "learning-cycle-module__I5UXMG__statusRing",
  "text": "learning-cycle-module__I5UXMG__text",
  "title": "learning-cycle-module__I5UXMG__title",
});
